<template>
  <div :style="styled">
    <div class="container-text">
      <div class="title-box">
        <span>{{ title }}</span>
      </div>
      <div class="title-box">
        <span>{{ subtitle }}</span>
      </div>
    </div>
    <feather :color="icon.color" :type="icon.type" :size="icon.size" />
  </div>
</template>

<script>
export default {
	props: {
		icon: {
			type: Object,
			default: () => ({
				type: 'filter',
				size: '30px',
				color: '#000000',
			})
		},
		title: {
			type: String,
			default: 'Valor'
		},
		subtitle: {
			type: String,
			default: '0'
		},
		fontSize: {
			type: String,
			default: '17px'
		},
		backgroundColor: {
			type: String,
			default: '#157b48'
		},
		marginLeft: {
			type: String,
			default: '0px'
		},
		marginRight: {
			type: String,
			default: '0px'
		},
		borderRadius: {
			type: String,
			default: '8px'
		},
		width: {
			type: String,
			default: '23%'
		},
		height: {
			type: String,
			default: '100px'
		},
		padding: {
			type: String,
			default: '15px'
		},
		borderWidth: {
			type: String,
			default: '0px'
		},
		borderStyle: {
			type: String,
			default: 'solid'
		},
		borderColor: {
			type: String,
			default: '#cecece'
		},
		letterSpacing: {
			type: String,
			default: '0',
		},
		display: {
			type: String,
			default: 'flex'
		},
		alignItems: {
			type: String,
			default: 'center',
		},
		justifyContent: {
			type: String,
			default: 'space-between',
		},
		fontFamily: {
			type: String,
			default: 'Sora, sans-serif !important',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		},
		color: {
			type: String,
			default: '#FFF',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		linearGradient: {
			type: Object,
			default: () => ({
				bgInital: '#0db2de',
				bgFinal: '#005bea'
			})
		}
	},
	computed: {
		styled() {
			return {
				fontSize: this.fontSize,
				backgroundImage: `linear-gradient(to left, ${this.linearGradient.bgInital} 0%, ${this.linearGradient.bgFinal} 100%) !important`,
				borderRadius: this.borderRadius,
				width: this.width,
				height: this.height,
				borderWidth: this.borderWidth,
				borderStyle: this.borderStyle,
				borderColor: this.borderColor,
				display: this.display,
				alignItems: this.alignItems,
				fontFamily: this.fontFamily,
				fontWeight: this.fontWeight,
				justifyContent: this.justifyContent,
				letterSpacing: this.letterSpacing,
				marginLeft: this.marginLeft,
				marginRight: this.marginRight,
				padding: this.padding,
				color: this.color,
				boxShadow: '-8px 12px 18px 0 #dadee8',
			};
		}
	}
};
</script>

<style scoped>
.container-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
</style>
